<template>
  <div class="this-skill-rating">
    <img v-for="i in this.maxRate" :src="getSource(i)" :key="i" alt="star rating" />
  </div>
</template>

<script>
export default {
  name: 'SkillRating',
  props: ['rate', 'max'],
  mounted() {
    if (!this.rate) {
      throw new Error('Rate have to be set');
    }
  },
  computed:{
    maxRate: function () {
      if (!this.max) {
        return 5;
      }
      return this.max;
    }
  },
  methods: {
    getSource: function (index) {
      if (index <= this.rate) {
        return require(`../assets/img/star_full.svg`);
      } else {
        return require(`../assets/img/star_empty.svg`);
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'src/assets/styles/variables';
  .this-skill-rating {
  }
</style>
